import {EventEmitter, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RealTimeService {

  public notificationBadgeListener: EventEmitter<any> = new EventEmitter();

  constructor() { }


}
